/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaskWorkflowTargetType = {
    All: 'ALL',
    Facility: 'FACILITY',
    SystemTag: 'SYSTEM_TAG',
    CustomTag: 'CUSTOM_TAG',
} as const;
export type TaskWorkflowTargetType = typeof TaskWorkflowTargetType[keyof typeof TaskWorkflowTargetType];


export function instanceOfTaskWorkflowTargetType(value: any): boolean {
    for (const key in TaskWorkflowTargetType) {
        if (Object.prototype.hasOwnProperty.call(TaskWorkflowTargetType, key)) {
            if (TaskWorkflowTargetType[key as keyof typeof TaskWorkflowTargetType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TaskWorkflowTargetTypeFromJSON(json: any): TaskWorkflowTargetType {
    return TaskWorkflowTargetTypeFromJSONTyped(json, false);
}

export function TaskWorkflowTargetTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskWorkflowTargetType {
    return json as TaskWorkflowTargetType;
}

export function TaskWorkflowTargetTypeToJSON(value?: TaskWorkflowTargetType | null): any {
    return value as any;
}

export function TaskWorkflowTargetTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): TaskWorkflowTargetType {
    return value as TaskWorkflowTargetType;
}

